export function getInstallationDetails(order: any): Record<string, any> {
  return order?.installation_details || {};
}

export function getRemovalDetails(order: any): Record<string, any> {
  return order?.removal_details || {};
}

export function getInstallationAddressForInvoice(order: any, shippingFallback: any): any {
  const installDetails = getInstallationDetails(order);
  return installDetails?.installation_address || order?.installation_address || shippingFallback;
}

export function getRemovalAddressForInvoice(order: any, shippingFallback: any): any {
  const removalDetails = getRemovalDetails(order);
  return removalDetails?.removal_address || order?.removal_address || shippingFallback;
}

/** Scheduled date string for install or removal job (from details). */
export function getJobScheduledDate(isInstall: boolean, isRemoval: boolean, order: any): string | undefined {
  const installDetails = getInstallationDetails(order);
  const removalDetails = getRemovalDetails(order);
  if (isInstall) return installDetails?.scheduled_date;
  if (isRemoval) return removalDetails?.scheduled_date;
  return undefined;
}
